export default __webpack_public_path__ + "static/media/background.b36bcd90.jpg";